module.exports = __webpack_public_path__ + "static/high-wheelers-masonic-a80c40ab86984e32edae8a76ce579b43.jpg";